// 获取token的存储key
function getTokenKey() {
    const appId = process.env.VUE_APP_APPID || ''
    return `${appId}token`
}

function setToken(token) {
    localStorage.setItem(getTokenKey(), token)
}

function getToken() {
    return localStorage.getItem(getTokenKey())
}

function removeToken() {
    localStorage.removeItem(getTokenKey())
}


/**
 * 解析 url 中的参数
 * @param url
 * @returns {Object}
 */
function parseUrlParams(url) {
    const params = {}
    if (!url || url === '' || typeof url !== 'string') {
        return params
    }
    const paramsStr = url.split('?')[1]
    if (!paramsStr) {
        return params
    }
    const paramsArr = paramsStr.replace(/&|=/g, ' ').split(' ')
    for (let i = 0; i < paramsArr.length / 2; i++) {
        const value = paramsArr[i * 2 + 1]
        params[paramsArr[i * 2]] = value === 'true' ? true : (value === 'false' ? false : value)
    }
    return params
}

module.exports = {
    setToken,
    getToken,
    removeToken,
    parseUrlParams,
}